export const readEmpty = async (skip,query,id) => {
    try{
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listDomisiliKokasUploaded?skip=${skip}&query=${query}&id=${id}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}